export default "__VITE_ASSET__CSi3AMkK__"